import { createFileRoute } from '@tanstack/react-router';
import { IndustryPresetForm } from '@/pages/super-admin/industry-presets/IndustryPresetForm';

export const Route = createFileRoute('/_authenticated/super-admin/industry-presets/new')({
	component: IndustryPresetForm,
});
